import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconSize, ShIconModule } from '../../../../elements/components/icon/icon.module';
import { LabelIcon } from '../form-label/label-icon.entity';

@Component({
    standalone: true,
    selector: 'sh-field-label',
    templateUrl: './field-label.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShIconModule]
})
export class ShFieldLabelComponent {
    public readonly IconSize: typeof IconSize = IconSize;

    public labelIcons = input<LabelIcon[]>([]);
    public label = input.required<string>();
}
